actionFlag = false;
actionFlag_timer = 500;	
function actionFlagUp(){actionFlag = true; setTimeout(function(){ actionFlag = false;}, actionFlag_timer);}

$("document").ready(function(){
	$('.postLst').masonry({
	  itemSelector: '.box-post-list',
	});

	$("#btn-more-posts").bind('click touchstart',function(){if (!actionFlag) {actionFlagUp();

		var currentPage = Number($("#page-current").html());	
		var lastPage = Number($("#page-last").html());

		if(currentPage < lastPage){
			getMorePosts();	
		}
		
	}});

});

function getMorePosts(){
    var page = $("#page-current").html();
	page = Number(page) + 1;
    var apiUrl = window.location.origin + "/api" + window.location.pathname + "?page=" + page;
	var transData = { 'page': page };
	
	$.ajax({
		type:'POST',
		url: apiUrl,
		data : transData,
		dataType: "json",
		success: function(res){
		  getPostList(res, "append");				  
		}
	});
	
}

function getPostList(coursePosts, action){
	if(action == "replace"){
		$(".postLst").html("");
	}
	
	var listHtml = "<div class='postLst'>";
	$.each(coursePosts.data, function(idx, val){
		console.log(val);
		listHtml += setPostBox(val);
	});
	
	listHtml += "</div>";
	
	


	listHtml = $.parseHTML(listHtml);

	
	$("#box-list").append(listHtml);
		
	$('#box-list .postLst .lazy').off().lazyload({
	      effect : "fadeIn",
	      effectspeed : 400 
	  });				
		
	$('#box-list .postLst').off().masonry({
	  itemSelector: '.box-post-list',
	});	
	var currentPage = coursePosts.current_page;
	var lastPage = coursePosts.last_page;
	$("#page-current").html(currentPage);	
	$("#page-last").html(lastPage);
	
	if(currentPage == lastPage){
		$(".btn-more-angle").css("display","none");
	}else{
		$(".btn-more-angle").css("display","block");		
	}
}

function setPostBox(post){
	var lmsUrl = $.getMeta('property','lms');
	console.log(post);
	var listBox = "<div class='box-post-list fl'>";
	listBox += "<a class='post-list-cover' href='" + window.location.pathname + "/" + post.post_slug + "'>";
	if(post.post_primary_image != null){
		listBox += "<div class='post-list-cover-image lazy' data-original='" + lmsUrl + '/local/ubocw/imgViewer.php?id=' + post.post_primary_image + "' style='background-image:url()'></div>";
	}else{
		listBox += "<div class='post-list-cover-image' style='background-image:url(/_src/common/no-image.png)'></div>";
	}
	listBox += "<p class='post-list-title'>" + post.post_title + "</p>";
	listBox += "<p class='post-list-desc'>" + $.tag_strip(post.post_desc) + "</p>";	
	listBox += "</a>";

	listBox += "<div class='bottomItem'>";

	if(post.post_writer !== "" && post.post_writer !== null){ 
		listBox += "<a href='#' style='display:block;'>";	
		listBox += "<span>";		
		listBox += post.post_writer;
		listBox += "</span>";
		listBox += "</a>";			
	}else{

		$.each(post.post_owner, function(idx, val){
			listBox += "<a href='/class/" + val.id + "' style='display:block;'>";	
			listBox += "<span>";			
			listBox += val.firstname;			
			listBox += "</span>";
			listBox += "</a>";			
		});

	}
	
	
	listBox += "</div>";	
	listBox += "</div>";						

	
	return listBox;
} 